import store from '../store'
import { HttpClient } from './httpClient'
import {
  merchandiseDuty,
  merchandiseLineItem,
  invoiceItemData,
  container,checkFrieghtShouldBeDispalyed,
  manufacturer
} from '../formSections/util/initialValues'
import {
  addDutyItem,
  addMerchandiseLineItem,
  createInvoiceLineItem,
  updateArticleSubComponent
} from '../actions/DescriptionOfMerchandiseActions'
import { addContainer } from '../actions/BOLInfoActions'
import { addManufacturer } from '../actions/ImporterActions'
import {saveMerchandiseObject} from './setFormData';
import _ from "lodash";
const createEvent = eventMessage => ({
  eventType: 'SAVE_ENTRY_SUMMARY_FORM',
  eventTime: Date.now(),
  eventMessage
})


export const createMerchandiseLineItem = (invoiceId ,invoiceItemIndex ,updateStatus , lineType, merchandiseId, pscShipId) => {
  let eventMsg = {
    descriptionOfMerchandise: {
      entrySummaryInvoices :[{
        shipmentId: pscShipId || window.shipmentId,
        invoiceId,
        merchandiseLineItems: [
          {
            // merchandiseDuties: [
            //   {
            //     unitPrice: 0
            //   }
            // ]
          }
        ]
      }]
    
    },
    shipmentId: pscShipId || window.shipmentId
  };
  if(lineType === 'NormalLineItem'){
    eventMsg.descriptionOfMerchandise.entrySummaryInvoices[0].merchandiseLineItems[0].merchandiseId = 'CREATE'
  }
  if(lineType === 'ArticleHeader'){
    eventMsg.descriptionOfMerchandise.entrySummaryInvoices[0].merchandiseLineItems[0].articleSetId = 'CREATE'
  }
  if(lineType === 'ArticleSetSubComponent'){
    eventMsg.descriptionOfMerchandise.entrySummaryInvoices[0].merchandiseLineItems[0].merchandiseId = 'CREATE'
    eventMsg.descriptionOfMerchandise.entrySummaryInvoices[0].merchandiseLineItems[0].articleSetId = merchandiseId;
  }
  let dataSent = createEvent(eventMsg)
  return HttpClient.post(dataSent)
    .then(response => {
      if(response.data.eventMessage.code && response.data.eventMessage.code!=200){
        console.log('ERROR::  CREATE MerchandiseDutyItem', response.data.eventMessage);
        return;
      }
      if(lineType === 'ArticleHeader' && response.data.eventMessage.merchandise){
        let merchandiseList = response.data.eventMessage.merchandise;
          merchandiseList.forEach((item)=>{
            let newLineItem = merchandiseLineItem()
            newLineItem.merchandiseId = item.merchandiseId
            newLineItem.grossWeight= { "weight": _.get(item, "grossWeight.weight") || "" }
            newLineItem.grossWeight.weightUnits=   _.get(item, "grossWeight.weightUnits")  || "None"
            newLineItem.productClaimCode=  item.productClaimCode || ""
            newLineItem.partRefreshFlag=  item.partRefreshFlag || ""
            newLineItem.categoryCode=  item.categoryCode || ""
            newLineItem.pgaFlags = item.pgaFlags || {}
            newLineItem.articleHeader = item.articleHeader || ''
            newLineItem.articleSetId = item.articleSetId || ''
            newLineItem.importerAdditionalDeclarationDetails = item.importerAdditionalDeclarationDetails || null
            newLineItem.seqNo = item.seqNo || ''
            if(item.articleHeader === 'X'){
              newLineItem.articleSubComponent = item.articleSubComponent || []
            }            
            newLineItem.merchandiseDuties[0].merchandiseDutyId =   item.merchandiseDuties[0].merchandiseDutyId
            //new added
            newLineItem.merchandiseDuties[0].manifestQuantity =  item.merchandiseDuties[0].manifestQuantity || {}
            newLineItem.merchandiseDuties[0].additionalQuantity =  item.merchandiseDuties[0].additionalQuantity || {}
            newLineItem.merchandiseDuties[0].unitPrice =  item.merchandiseDuties[0].unitPrice || ""
            newLineItem.merchandiseDuties[0].enteredValue =  item.merchandiseDuties[0].enteredValue || "0.00"
            newLineItem.merchandiseDuties[0].dutyRate =  item.merchandiseDuties[0].dutyRate || ""
            newLineItem.merchandiseDuties[0].duty =  item.merchandiseDuties[0].duty || ""
            newLineItem.merchandiseDuties[0].charges =  item.merchandiseDuties[0].charges || ""
            newLineItem.merchandiseDuties[0].IRTax =  item.merchandiseDuties[0].IRTax || ""
            newLineItem.merchandiseDuties[0].otherFee =  item.merchandiseDuties[0].otherFee || ""
            newLineItem.merchandiseDuties[0].mpf =  item.merchandiseDuties[0].mpf || {}
            newLineItem.merchandiseDuties[0].hmf =  item.merchandiseDuties[0].hmf || {}
            newLineItem.merchandiseDuties[0].specificRate =  item.merchandiseDuties[0].specificRate || ""
            newLineItem.merchandiseDuties[0].otherRate =  item.merchandiseDuties[0].otherRate || ""
            newLineItem.merchandiseDuties[0].adValoremDuty =  item.merchandiseDuties[0].adValoremDuty || ""
            newLineItem.merchandiseDuties[0].specificDuty =  item.merchandiseDuties[0].specificDuty || ""
            newLineItem.merchandiseDuties[0].otherDuty =  item.merchandiseDuties[0].otherDuty || ""
            newLineItem.merchandiseDuties[0].additionalDuties =  item.merchandiseDuties[0].additionalDuties || {}
            newLineItem.merchandiseDuties[0].adcvd =  item.merchandiseDuties[0].adcvd || {}
            // end new added
            newLineItem.merchandiseDuties[0].isCommodityDuty =  item.merchandiseDuties[0].isCommodityDuty
           
            newLineItem.merchandiseDuties[0].charges =  (parseFloat(item.merchandiseDuties[0].charges) || 0).toFixed(2)
             
            newLineItem.commodityMerchandiseDutyId =  item.merchandiseDuties[0].merchandiseDutyId
           
            newLineItem.manufacturerId =   item.merchandiseDuties[0].manufacturerId
          
            store.dispatch(addMerchandiseLineItem(invoiceItemIndex ,newLineItem));
          })
      }else if(lineType === 'ArticleSetSubComponent' || lineType === 'NormalLineItem' ){
        let newLineItem = merchandiseLineItem()
        newLineItem.merchandiseId = response.data.eventMessage.merchandiseId
       newLineItem.grossWeight.weight=  _.get(response, 'data.eventMessage.grossWeight.weight') || ""
       newLineItem.grossWeight.weightUnits=  _.get(response, 'data.eventMessage.grossWeight.weightUnits') || "None"
        newLineItem.productClaimCode=  _.get(response, 'data.eventMessage.productClaimCode') || ""
        newLineItem.partRefreshFlag=  _.get(response, 'data.eventMessage.partRefreshFlag') || ""
        newLineItem.categoryCode=  _.get(response, 'data.eventMessage.categoryCode') || ""
        newLineItem.importerAdditionalDeclarationDetails =  _.get(response, 'data.eventMessage.importerAdditionalDeclarationDetails') || null
        
        newLineItem.merchandiseDuties[0].merchandiseDutyId =response.data.eventMessage?.merchandiseDuties && response.data.eventMessage?.merchandiseDuties[0]?.merchandiseDutyId||''
          
        newLineItem.merchandiseDuties[0].isCommodityDuty =  response.data.eventMessage?.merchandiseDuties[0]?.isCommodityDuty||''
        newLineItem.merchandiseDuties[0].manifestQuantity =  _.get(response, 'data.eventMessage.merchandiseDuties[0].manifestQuantity') || {}
        newLineItem.merchandiseDuties[0].additionalQuantity =  _.get(response, 'data.eventMessage.merchandiseDuties[0].additionalQuantity') || {}
        newLineItem.merchandiseDuties[0].unitPrice =  (parseFloat(_.get(response, 'data.eventMessage.merchandiseDuties[0].unitPrice') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].enteredValue =  (parseFloat(_.get(response, 'data.eventMessage.merchandiseDuties[0].enteredValue')||0)) || ""
        newLineItem.merchandiseDuties[0].charges =   (parseFloat(response.data.eventMessage.merchandiseDuties[0].charges) || 0).toFixed(2)
        newLineItem.merchandiseDuties[0].enteredValue =   (parseFloat(_.get(response, 'data.eventMessage.merchandiseDuties[0].enteredValue') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].dutyRate =   (parseFloat(_.get(response, 'data.eventMessage.merchandiseDuties[0].dutyRate') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].duty =   (parseFloat(_.get(response, 'data.eventMessage.merchandiseDuties[0].duty') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].IRTax =   (parseFloat(_.get(response, 'data.eventMessage.merchandiseDuties[0].IRTax') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].otherFee =   (parseFloat(_.get(response, 'data.eventMessage.merchandiseDuties[0].otherFee') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].mpf =  _.get(response, 'data.eventMessage.merchandiseDuties[0].mpf')||{}
        newLineItem.merchandiseDuties[0].hmf =  _.get(response, 'data.eventMessage.merchandiseDuties[0].hmf')||{}
        newLineItem.merchandiseDuties[0].specificRate =   (parseFloat(_.get(response, 'data.eventMessage.merchandiseDuties[0].specificRate') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].otherRate =   (parseFloat(_.get(response, 'data.eventMessage.merchandiseDuties[0].otherRate') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].adValoremDuty =   (parseFloat(_.get(response, 'data.eventMessage.merchandiseDuties[0].adValoremDuty') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].specificDuty =   (parseFloat(_.get(response, 'data.eventMessage.merchandiseDuties[0].specificDuty') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].otherDuty =   (parseFloat(_.get(response, 'data.eventMessage.merchandiseDuties[0].otherDuty') || 0)).toFixed(2)
        newLineItem.merchandiseDuties[0].adcvd =  _.get(response, 'data.eventMessage.merchandiseDuties[0].adcvd')||{}
        
        newLineItem.commodityMerchandiseDutyId =   response.data.eventMessage.merchandiseDuties[0].merchandiseDutyId||''
        
        newLineItem.manufacturerId =  response.data.eventMessage.merchandiseDuties[0].manufacturerId||''
         
          newLineItem.seqNo =  response.data.eventMessage.seqNo || ''
          newLineItem.pgaFlags =  _.get(response, 'data.eventMessage.pgaFlags') || {}
          if(response.data.eventMessage.articleHeader === 'V'){
            newLineItem.articleHeader =  response.data.eventMessage.articleHeader || ''
            newLineItem.articleSetId =  response.data.eventMessage.articleSetId || ''
            store.dispatch(updateArticleSubComponent(response.data.eventMessage.articleSetId, response.data.eventMessage.merchandiseId , invoiceItemIndex))
          }
        store.dispatch(addMerchandiseLineItem(invoiceItemIndex , newLineItem))
      }
      updateStatus(merchandiseId)
    })
}

export const createMerchandiseDutyItem = (invoiceItemIndex,invoiceId, merchandiseId, merchIndex, dutyAddStatus, hts = '', pscShipId, data) => {
  if(data?.htsNo & hts){
    let dedupeString = 'AddedMerchandise'+merchandiseId+"XX"+merchIndex+"XX"+dutyAddStatus+"XX"+hts+JSON.stringify(data);
    if((window[dedupeString]||0)+30000 > Date.now() )return;
    window[dedupeString] = Date.now();

  }
  let dataSent = createEvent({
    descriptionOfMerchandise: {
      entrySummaryInvoices:[{
        invoiceId,
        merchandiseLineItems: [
          {  
            shipmentId: window.shipmentId,
            merchandiseId,
            merchandiseDuties: [
              {
                unitPrice: 0,
                htsus: (data?.htsNo || "").replaceAll(".","").trim(),
                htsDescription: data?.displayDescription || ""
              }
            ]
          }
        ]

      }]
     
    },
    shipmentId: (pscShipId || window.shipmentId)
  })
  console.log('CREATE MerchandiseDutyItem', dataSent)
  return HttpClient.post(dataSent).then(response => {
    if(!response?.data?.eventMessage){
      alert(`CREATION OF SUBDUTY HAS FAILED! ${hts}! ${JSON.stringify(response)}`);
      console.log('Response', response)
      return;

    }
    dutyAddStatus && dutyAddStatus()
    console.log('Response', response)
    let newDutyItem = merchandiseDuty(hts)
    newDutyItem.isCommodityDuty =
      response.data.eventMessage.isCommodityDuty || 2
    let commodityDuty = newDutyItem.isCommodityDuty;
    newDutyItem.merchandiseDutyId = response.data.eventMessage.merchandiseDutyId
    if(data){
      newDutyItem.htsus = (data.htsNo || "").replaceAll(".","").trim();
      newDutyItem.whenDutyItemCreated = Date.now();
      newDutyItem.htsDescription = data.displayDescription || "";
      if(data.applicableDuty){ 
        newDutyItem.dutyRate = data.applicableDuty
      }
    }
    store.dispatch(addDutyItem(invoiceItemIndex, merchIndex, newDutyItem))
    // This saves the incorrect duty rate and sets the ui duty to 0 :(
    // saveDutyRate(invoiceId, merchandiseId, pscShipId, data, newDutyItem.merchandiseDutyId, commodityDuty)
  })
}

// const saveDutyRate = (invoiceId, merchandiseId, pscShipId, data, merchandiseDutyId, commodityDuty) => {
//   let eventMsg = {
//     descriptionOfMerchandise: {
//       entrySummaryInvoices:[{
//         invoiceId,
//         merchandiseLineItems: [
//           {  
//             shipmentId: window.shipmentId,
//             merchandiseId,
//             merchandiseDuties: [
//               {
//                 "merchandiseDutyId": merchandiseDutyId,
//                 "dutyRate": data?.applicableDuty || "0.00",
//                 "isCommodityDuty": commodityDuty
//               }
//             ]
//           }
//         ]

//       }]
     
//     },
//     shipmentId: (pscShipId || window.shipmentId)
//   }
//   saveMerchandiseObject(eventMsg.descriptionOfMerchandise, window.shipmentId)
// }

export const createContainer = index => {
  let dataSent = createEvent({
    bolInfo: {
      container: [
        {
          number: '',
          size: ''
        }
      ]
    },
    shipmentId: window.shipmentId
  })
  console.log('CREATE Container', dataSent)
  return HttpClient.post(dataSent).then(response => {
    console.log('Response', response)
    let newContainer = container()
    newContainer.containerId =
      response.data.eventMessage.bolInfo.container[0].containerId
    newContainer.size =
      response.data.eventMessage.bolInfo.container[0].size
    store.dispatch(addContainer(newContainer))
  })
}

export const createManufacturer = () => {
  let dataSent = createEvent({
    importer: {
      headerParties: [
        {
          headerPartyType: "MANUFACTURER",
        }
      ]
    },
    shipmentId: window.shipmentId
  })
  console.log('CREATE Manufacturer', dataSent)
  let newManufacturer = manufacturer()
  store.dispatch(addManufacturer(newManufacturer))
  // return HttpClient.post(dataSent).then(response => {
  //   newManufacturer.headerId =
  //     response.data.eventMessage.importer.headerParties[0].headerId
  //   console.log('Response', response)
  // })
}

export const createInvoice = (totalInvoiceItem , updateStatus, shipmentId) => {
  if(!shipmentId){alert('missing shipmentId! Error!');return;}
  let eventMsg = {
    descriptionOfMerchandise: {
      entrySummaryInvoices: [
        {
          shipmentId: shipmentId 
        }
      ]
    },
    shipmentId: shipmentId
  }
  let dataSent = createEvent(eventMsg)
  return HttpClient.post(dataSent)
    .then(response => {
    
      if(response.data.eventMessage.code && response.data.eventMessage.code!=200){
        console.log('ERROR::  create invoice', response.data.eventMessage);
        return;
      }
      if(response.data.eventMessage){
            let newInvoiceItem = invoiceItemData()
            newInvoiceItem.invoiceId = response.data.eventMessage.invoiceId||''
        newInvoiceItem.invoiceNumber = response.data.eventMessage.invoiceNumber||''
        newInvoiceItem.invoiceDate = response.data.eventMessage.invoiceDate || '-999'
        newInvoiceItem.poNumber  = response.data.eventMessage.poNumber ||''
        newInvoiceItem.frieghtCharges= response.data.eventMessage.frieghtCharges||''
        newInvoiceItem.frieghtInsurance= response.data.eventMessage.frieghtInsurance||''
        newInvoiceItem.showLoader= false
        newInvoiceItem.expandInvoiceItem  = totalInvoiceItem < 5 ? true : false
        // newInvoiceItem.showFrightData= checkFrieghtShouldBeDispalyed(response.data.eventMessage.frieghtCharges,response.data.eventMessage.frieghtInsurance , response.data.eventMessage.otherDeductions)
        newInvoiceItem.otherDeductions= response.data.eventMessage.otherDeductions||''
        newInvoiceItem.totalEnteredValue= response.data.eventMessage.totalEnteredValue||''
        newInvoiceItem.invoiceAmount  =  (response.data.eventMessage.invoiceAmount  ==="0.0" || response.data.eventMessage.invoiceAmount  ==="-999.0") ?  "" : response.data.eventMessage.invoiceAmount ||'' 
        newInvoiceItem.merchandiseLineItems = response.data.eventMessage.merchandiseLineItems||[]
        store.dispatch(createInvoiceLineItem(newInvoiceItem));
          }
          updateStatus()
      }
    )}

